import { Box, Button, FormGroup, Grid, Paper, Stack, Typography } from '@mui/material';
import MessageDisplay from '../../../Shared/MessageDisplay';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import { fetchQRCode } from '../../../../store/providerNavbar.slice';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningIcon from '@mui/icons-material/Warning';
import { useState } from 'react';
import Authorization from '../../../../utils/Authorization';

const GetMFAQRCode = () => {
    const dispatch = useAppDispatch();
    const { qrCode, secretKey } = useSelector((state: RootState) => state.providerNavbar);
    const [lockGenerate, setLockGenerate] = useState(false);
    const [authData] = useState(new Authorization());

    const getQRCodeHandler = async () => {
        setLockGenerate(true);
        dispatch(fetchQRCode());
    };

    return (
        <Box p={2}>
            <MessageDisplay />
            <Stack direction="row" alignItems={'center'} spacing={2}>
                <Typography variant="h6" fontWeight="bold">
                    Generate QR Code
                </Typography>
            </Stack>

            <Grid container height={'60vh'} alignItems={'center'} justifyContent={'center'}>
                <Grid size={4}>
                    <Paper elevation={3} sx={{ padding: '16px' }}>
                        <FormGroup>
                            <Box justifyContent={'center'} alignItems="center" display="flex" flexDirection="column">
                                {qrCode && <div style={{ width: '150px', height: '150px' }} dangerouslySetInnerHTML={{ __html: qrCode }} />}
                            </Box>
                            <Box justifyContent={'center'} alignItems="center" display="flex" flexDirection="column">
                                {secretKey && (
                                    <Stack direction={'row'} alignItems="center" spacing={1} marginTop={2}>
                                        <Typography variant="body1">Secret Key: {secretKey}</Typography>
                                        <ContentCopyIcon
                                            onClick={() => {
                                                navigator.clipboard.writeText(secretKey);
                                            }}
                                            sx={{ cursor: 'pointer', marginLeft: 1 }}
                                            color="info"
                                        />
                                    </Stack>
                                )}
                            </Box>
                            <Stack spacing={2} direction="column" justifyContent="flex-end" marginTop={5}>
                                {(authData.MFAQRLocked || lockGenerate) && (
                                    <Typography fontWeight="bold">Please contact admin if you need to generate another QR code.</Typography>
                                )}
                                {!authData.MFAQRLocked && !lockGenerate && (
                                    <>
                                        <Typography>
                                            By clicking 'Generate QR Code,' you will need to immediately scan the new QR code using your authenticator app or
                                            manually add the account with secret key to your authenticator app.
                                        </Typography>
                                        <Typography> This app will then create password codes required for future logins.</Typography>
                                    </>
                                )}
                                <Button
                                    disabled={authData.MFAQRLocked || lockGenerate}
                                    variant="contained"
                                    color="primary"
                                    onClick={getQRCodeHandler}
                                    endIcon={<WarningIcon />}
                                >
                                    Generate QR Code
                                </Button>
                            </Stack>
                        </FormGroup>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default GetMFAQRCode;
